import React from 'react';

// Skupni ovoj za end-user PWA strani (prijava/registracija/dom).
export default function EndUserShell({ title, children, wide }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '24px 16px' }}>
      <div style={{ width: '100%', maxWidth: wide ? 560 : 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <img src="/logo192.png" alt="AvtoRadar" style={{ width: 64, height: 64, borderRadius: 16 }} />
          <h1 style={{ fontSize: 22, margin: '10px 0 2px' }}>AvtoRadar</h1>
          {title && <div style={{ color: '#666' }}>{title}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}

export const card = { background: '#fff', border: '1px solid #e5e5e5', borderRadius: 14, padding: 18, marginBottom: 14 };
export const inputStyle = { width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 16, marginBottom: 10, boxSizing: 'border-box' };
export const btnStyle = { width: '100%', padding: '13px', background: '#0066cc', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer' };
export const labelStyle = { fontSize: 13, fontWeight: 600, color: '#333', margin: '6px 0 4px' };
